'use client';

import { useAuthBoot } from '../context/AuthBootContext';
import { useLoginDisplay } from '../hooks/useLoginDisplay';

export const WelcomeText = (): React.ReactElement | null => {
    const { authBoot } = useAuthBoot();
    const { displayWebviewEscapeScreen } = useLoginDisplay();

    const {
        text = 'Welcome to appcharge store!',
        textColor = '#ffffff',
        textSize = 24,
        textWeight = 'normal',
        font,
    } = authBoot.storeTheme.login;

    const fontFamily = font || authBoot.storeTheme.general?.font;

    if (!text || displayWebviewEscapeScreen) return null;

    // Fixed line-height keeps vertical metrics stable across webfont swap
    // without changing the visible title styling.
    const lineHeight = 1.25;

    return (
        <h2
            data-testid="loginPageTitle"
            className="w-full text-center"
            style={{
                color: textColor,
                fontSize: `${textSize}px`,
                fontWeight: textWeight,
                fontFamily: fontFamily,
                lineHeight,
                minHeight: `${textSize * lineHeight}px`,
            }}
        >
            {text}
        </h2>
    );
};
